import { supabase } from "@/shared/lib/supabaseClient";
import type { Database } from "@/shared/types/database.types";

/**
 * Dados administrativos da Igreja (03-Núcleo §3). A tela opera sobre a igreja do
 * usuário logado (RLS limita a leitura à própria igreja).
 * Dados editáveis: nome e contato para pedidos sobre dados pessoais (migration 0103).
 * O `codigo` (link de cadastro /cadastro/<codigo>) só muda pelo banco: mudar quebra
 * os links já enviados.
 *
 * VISÃO SaaS (decisão de 09/10/2026, análise para o futuro em docs/oficial/arquitetura.md (seção 9)):
 * por enquanto só existe o link de cadastro por igreja. Ainda NÃO existem tela de
 * criação de igreja, cobrança/assinatura, termos/DPA nem conta ligada a várias igrejas.
 * RLS: qualquer autenticado vê; só admin da plataforma atualiza.
 */

export type Igreja = Database["public"]["Tables"]["igrejas"]["Row"];

export interface DadosIgrejaEditaveis {
  nome: string;
  contato_email: string | null;
  contato_telefone: string | null;
}

export const igrejaService = {
  async buscar(): Promise<Igreja> {
    const { data, error } = await supabase.from("igrejas").select("*").limit(1).single();
    if (error || !data) throw new Error("Não foi possível carregar as informações da igreja.");
    return data;
  },

  async atualizar(id: string, dados: DadosIgrejaEditaveis): Promise<void> {
    const { error } = await supabase.from("igrejas").update(dados).eq("id", id);
    if (error) throw new Error("Não foi possível salvar as informações da igreja.");
  },
};
